// 404 page (audit UI-02). The catch-all used to silently redirect unknown
// routes to "/", hiding broken links; now it shows a real not-found state.
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Compass } from 'lucide-react';

export function NotFoundPage() {
  const { t } = useTranslation('pages');
  const navigate = useNavigate();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-8 text-center">
      <Compass size={40} className="text-muted" />
      <div className="text-2xl font-semibold tk-num">404</div>
      <p className="max-w-md text-sm text-muted">{t('notFound.hint')}</p>
      <button className="tk-btn-primary" onClick={() => navigate('/')}>{t('notFound.back')}</button>
    </div>
  );
}
